import $ from "jquery"
import "foundation-sites"
import "what-input"

import "./flatpickr"

// Foundation.addToJquery($);
Foundation.Abide.defaults['validators']['datestamp'] =
  function ($evt, required, parent) {
    var evt = $evt;
    return evt[0].value.match('[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}') ? true : false;
  };

$(document).foundation();

$(document).ready(function () {
  $('form[data-abide]').bind('forminvalid.zf.abide', function (e, target) {
    // console.log('scrolling to first error', e, target)
    setTimeout(function () {
      $('.is-invalid-label, [data-invalid]')[0].scrollIntoView({ behavior: 'smooth' })
    });
  });

  // Step 1 reCAPTCHA v3 (invisible) integration.
  $('#event-info').on('submit', function (e) {
    const $form = $(this);
    const siteKey = $form.data('recaptcha-site-key');
    const action = $form.data('recaptcha-action');

    if (!siteKey || $form.data('recaptcha-verified') === true) return true;
    if (!window.grecaptcha || typeof window.grecaptcha.execute !== 'function') return true;

    e.preventDefault();
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute(siteKey, { action: action }).then(function (token) {
        $form.find('#recaptcha-token').val(token);
        $form.data('recaptcha-verified', true);
        $form[0].submit();
      }).catch(function () {
        $form[0].submit();
      });
    });

    return false;
  });

  //Phone require/toggling
  // $("#inquiry_customer_attributes_preferred_contact_method_phone").on("click", function () {
  //   $("#inquiry_customer_attributes_phone").attr("required", true);
  //   $("#inquiry_customer_attributes_email").removeAttr("required").removeClass("is-invalid-input");
  //   $("label[for=inquiry_customer_attributes_email]").removeClass("is-invalid-label");
  //   $(".form-error.email").removeClass("is-visible");
  // })
  //Email require/toggling
  // $("#inquiry_customer_attributes_preferred_contact_method_email").on("click", function () {
  //   $("#inquiry_customer_attributes_email").attr("required", true);
  //   $("#inquiry_customer_attributes_phone").removeAttr("required").removeClass("is-invalid-input");
  //   $("label[for=inquiry_customer_attributes_phone]").removeClass("is-invalid-label");
  //   $(".form-error.phone").removeClass("is-visible");
  // })

  //Event type Other toggle
  $('.event-type input[type=radio]').on('change', function () {
    const $group = $(this).closest('.event-type').find('.other-group');
    const $otherLabel = $group.find('.event-other');
    const $otherInput = $group.find('#inquiry_event_type_other');

    if ($(this).attr("id") == "inquiry_event_type_code_other") {
      $otherLabel.show();
      $otherInput.show();
    } else {
      $otherLabel.hide();
      $otherInput.hide();
    }
  });
  $('.event-type input[type=radio]:checked').trigger('change');
  $('.event-style input[type=radio]').on('change', function () {
    if ($(this).attr("id") == "inquiry_event_style_code_other") {
      $("#inquiry_event_style_other").show();
      $(".event-other").show();
      $("#inquiry_event_style_other").attr("required", true);
    }
    else {
      $("#inquiry_event_style_other").hide();
      $(".event-other").hide();
      $("#inquiry_event_style_other").attr("required", false);
    }
  });

  // Rejection form handling
  $('#refuse-button').on('click', function () {
    $('#refuse-button').hide();
    $('#rejection-form').show();
  });

  $('#cancel-refuse').on('click', function () {
    $('#rejection-form').hide();
    $('#refuse-button').show();
    // Reset form
    $('#rejection-reason-form')[0].reset();
    $('#custom-reason-container').hide();
  });

  // Handle "Other" rejection reason selection
  $('input[name="rejection_reason"]').on('change', function () {
    if ($(this).val() === 'other') {
      $('#custom-reason-container').show();
      $('#custom_rejection_reason').attr('required', true);
    } else {
      $('#custom-reason-container').hide();
      $('#custom_rejection_reason').attr('required', false);
    }
  });

  // Form validation for rejection reasons
  $('#rejection-reason-form').on('submit', function (e) {
    var selectedReason = $('input[name="rejection_reason"]:checked').val();

    if (!selectedReason) {
      e.preventDefault();
      alert('Please select a reason for refusing this request.');
      return false;
    }

    if (selectedReason === 'other') {
      var customReason = $('#custom_rejection_reason').val().trim();
      if (!customReason) {
        e.preventDefault();
        alert('Please provide a custom reason for refusing this request.');
        $('#custom_rejection_reason').focus();
        return false;
      }
    }

    return true;
  });
});
